export const TYPE_FORM_MODAL = 'typeform_modal';
export const CONNECT_CLIENT_SITE_MODAL = 'connect_client_site_modal';
